import { autoFormOptions, gen, preformOptions } from '../../views/utils'

export default {
  auto: '*',
  store: {
    // TODO: implement
    // computed: {
    //   name({ brand, model }) {
    //     return `${brand} ${model}`
    //   },
    // },

    getters: {
      genVehicle: gen(() => ({
        clientId: null,
        brand: '',
        model: '',
        plate: '',
      })),
      formVehiclesOptions: preformOptions({
        value: ({ brand, model, plate }) => [`${brand} ${model}`, plate],
      }),
      vehiclesOptions: autoFormOptions('Vehicles'),
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicles.js